module.exports = __webpack_public_path__ + "img/loan_number.14570844.png";